import React, { useEffect, useState } from "react";
import "./adminnav.css";
import { getStoredUser, fetchArray } from "../../shared/useRoleDashboard";
import { Link, NavLink, useNavigate } from "react-router-dom";

const groups = [
  [
    "WORKSPACE",
    [
      ["/AdminDashboardPage", "Dashboard", "chart-pie"],
      ["/AssetDetails", "Asset Details", "layer-group"],
      ["/AssetRegister", "Asset Registration", "circle-plus"],
      ["/category", "Asset Categorize", "shapes"],
    ],
  ],
  [
    "OPERATIONS",
    [
      ["/pendingRegisterasset", "Pending Asset", "clock"],
      //["/transfer-form", "Asset Transfer", "arrow-right-arrow-left"],
      ["/PendingDiscardAsset", "Discard Asset", "trash-can"],
    ],
  ],
  [
    "MANAGEMENT",
    [
      ["/Users", "Users", "users"],
      ["/UsersRole", "Add Users Role", "user-plus"],
      ["/GetReport", "Get Report", "chart-column"],
      ["/TransferAssetReport", "Transfer Report", "file-lines"],
    ],
  ],
];
export default function AdminNavBar() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [user, setUser] = useState(getStoredUser);
  useEffect(() => {
    const controller = new AbortController();
    const stored = getStoredUser();
    if (!stored.username) return;
    fetchArray("/api/users/getallUsers", controller.signal)
      .then(users => {
        const profile = users.find(item => item.username === stored.username);
        if (!controller.signal.aborted && profile) {
          setUser({ username: profile.username, companyName: profile.companyName });
        }
      })
      .catch(() => {
        // Keep the saved user and Vella fallback when the profile is unavailable.
      });
    return () => controller.abort();
  }, []);
  const name = user?.username || "Administrator";
  const companyLogos = {
    "98 Acres": "98-acres",
    "Ravana Pool Club": "ravana",
    "Flying Ravana": "flying-ravana",
    "Le Maas Tota": "villa",
    "Tea Factory": "tea-factory",
    "Walaa kulu": "walaa",
    "Halpe Tea": "halpe",
    "Ella Swing": "ella-swing",
    "Halpe Tea Tour": "halpe-tour",
    "Amber Swing Kandy": "amber-swing",
    "Ceylon Tea Supermarket": "ceylon-tea",
  };
  const companyName = (user?.companyName || "").trim().replace(/\s+/g, " ");
  const companyLogo = /^uhe exports?$/i.test(companyName)
    ? "halpe"
    : companyLogos[companyName];
  const companyLabel = companyLogo
    ? user.companyName
    : "Vella Group of Companies";
  return (
    <div className="vella-navigation">
      <header className="vl-topbar">
        <button
          className="vl-menu"
          aria-label="Toggle navigation"
          aria-expanded={open}
          aria-controls="vella-sidebar"
          onClick={() => setOpen(!open)}
        >
          <i className="fas fa-bars" />
        </button>
        <Link
          to="/AdminDashboardPage"
          className={"vl-topbrand" + (companyLogo ? " vl-company-brand" : "")}
        >
          <img
            src={"/brands/" + (companyLogo || "vella") + ".jpeg"}
            alt={companyLabel}
          />
        </Link>
        <span className="vl-top-title">
          Asset Management <span>/ Administration</span>
        </span>
        <div className="vl-top-actions">
          <span className="vl-workspace">
            <span /> Group workspace
          </span>
          <span className="vl-avatar">{name.slice(0, 2).toUpperCase()}</span>
        </div>
        <div
          className="vl-company-logos"
          role="region"
          aria-label="Vella group company logos"
          tabIndex={0}
        >
          {Object.entries(companyLogos).map(([company, logo]) => (
            <div className="vl-company-logo" key={logo} title={company}>
              <img src={"/brands/" + logo + ".jpeg"} alt={company} />
            </div>
          ))}
        </div>
      </header>
      {open && (
        <button
          className="vl-overlay"
          aria-label="Close navigation"
          onClick={() => setOpen(false)}
        />
      )}
      <aside
        id="vella-sidebar"
        className={"vl-sidebar" + (open ? " is-open" : "")}
      >
       
        
        <Link className="vl-sidebar-logo" to="/AdminDashboardPage" onClick={() => setOpen(false)} aria-label="Vella dashboard">
          <img src="/brands/vella.jpeg" alt="Vella Group of Companies" width="112" height="24" />
        </Link>
        <nav aria-label="Admin navigation">
          {groups.map(([title, links]) => (
            <div className="vl-nav-group" key={title}>
              <p>{title}</p>
              {links.map(([to, label, icon]) => (
                <NavLink
                  key={to}
                  to={to}
                  onClick={() => setOpen(false)}
                  className={({ isActive }) =>
                    "vl-nav-link" + (isActive ? " active" : "")
                  }
                >
                  <i className={"fas fa-" + icon} />
                  <span>{label}</span>
                </NavLink>
              ))}
            </div>
          ))}
        </nav>
        <div className="vl-sidebar-bottom">
          <span className="vl-avatar">{name.slice(0, 2).toUpperCase()}</span>
          <div>
            <strong>{name}</strong>
            <small>Administrator</small>
          </div>
          <button
            aria-label="Sign out"
            title="Sign out"
            onClick={() => {
              if (window.confirm("Sign out of Vella?")) {
                localStorage.removeItem("currentUser");
                localStorage.removeItem("token");
                navigate("/");
              }
            }}
          >
            <i className="fas fa-arrow-right-from-bracket" />
          </button>
        </div>
      </aside>
    </div>
  );
}
